import type { Authenticator } from './types';
import { AuthenticatorType } from './types';

type DoesAuthenticatorSupportImageRenderingCookie = (authenticator: Authenticator) => boolean;
export const doesAuthenticatorSupportImageRenderingCookie: DoesAuthenticatorSupportImageRenderingCookie = (
  authenticator
): boolean => ![AuthenticatorType.TeamsMeeting, AuthenticatorType.TeamsMeetingV2].includes(authenticator.type);
